"use strict";
/*
Copyright 2021 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplunkConnectivityInstrumentation = void 0;
const core_1 = require("@opentelemetry/core");
const instrumentation_1 = require("@opentelemetry/instrumentation");
const version_1 = require("./version");
const MODULE_NAME = 'splunk-connectivity';
class SplunkConnectivityInstrumentation extends instrumentation_1.InstrumentationBase {
    constructor(config = {}) {
        super(MODULE_NAME, version_1.VERSION, Object.assign({}, config));
        // For apps with offline support 
        this.offlineStart = navigator.onLine ? null : (0, core_1.hrTime)();
    }
    init() { }
    enable() {
        this.offlineListener = () => {
            this.offlineStart = (0, core_1.hrTime)();
        };
        this.onlineListener = () => {
            if (this.offlineStart) {
                // this could be a span but let's keep it as an "event" for now.
                this._createSpan(false, this.offlineStart);
                this._createSpan(true, (0, core_1.hrTime)());
            }
        };
        window.addEventListener('offline', this.offlineListener);
        window.addEventListener('online', this.onlineListener);
    }
    disable() {
        window.removeEventListener('offline', this.offlineListener);
        window.removeEventListener('online', this.onlineListener);
    }
    _createSpan(online, startTime) {
        const span = this.tracer.startSpan('connectivity', { startTime });
        span.setAttribute('online', online);
        span.end(startTime);
    }
}
exports.SplunkConnectivityInstrumentation = SplunkConnectivityInstrumentation;
//# sourceMappingURL=SplunkConnectivityInstrumentation.js.map